<template>
  <nav v-if="role == 'booster'">
    <v-textarea dense outlined disabled class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
      :placeholder="$t('surveyTextareaParticipantPlaceholder')" data-testid="open-textarea" />
  </nav>
  <nav v-else>
    <v-textarea v-model="answer" dense outlined class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto" hide-details
      data-testid="open-textarea" @change="answerQuestion" />
    <p v-if="showError" class="error--text font-italic">{{ $t('answerError') }}</p>
  </nav>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => { }
    },
    role: {
      type: String,
      default: 'booster'
    },
    invalidAnswers: {
      type: Array,
      default: () => []
    },
    hasSubmittedSurvey: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      answer: '',
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        answer: ''
      },
      showError: false
    }
  },
  created() {
    //check if question was already submitted
    // const found = this.answers.find(object => object.id  == this.question.id);
    // if(found){
    //   this.answerObject = found
    // }
    this.$emit('sendAnswer', this.answerObject)
  },
  watch: {
    invalidAnswers() {
      this.showError = false
      if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
        this.showError = true
      }
    },
  },
  methods: {
    answerQuestion() {
      this.answerObject.answer = this.answer
      this.$emit('sendAnswer', this.answerObject)
    }
  }
}
</script>